import React, {useState} from "react";
import "./meetingDetailsControls.scss";
import PropTypes from "prop-types";
import {ReactComponent as SearchIcon} from "../../assets/icons/MagnifyingGlass.svg";
import {ReactComponent as CloseIcon} from "../../assets/icons/Close.svg";
import {ReactComponent as NextSearchIcon} from "../../assets/icons/ArrowDown.svg";
import {ReactComponent as PreviousSearchIcon} from "../../assets/icons/ArrowUp.svg";
import {IconButton, InputBase, Paper} from "@mui/material";
import CustomSwitch from "../Switch/Switch";

const MeetingDetailsControls = ({onSearchKeywordChange, currentSearchIndex, totalMatchesFound,goToNextSearchedItem,goToPreviousSearchedItem, onAutoScrollToggleChange,showAutoScroll, searchKeyword}) => {
    const [search, setSearch] = useState(searchKeyword);
    const [searchStarted, setSearchStarted] = useState(false);

    const handleSearchKeywordChange = (e) => {
        const changedString = e.target.value;
        setSearch(changedString);

        if(searchStarted && changedString === '') {
            handleRemoveSearch();
        }
    }
    const handleRemoveSearch = () => {
        setSearchStarted(false);
        onSearchKeywordChange(false);
        setSearch('');
    }
    const onSearchChange = () => {
        setSearchStarted(true);
        const searchKeyword = search?.trim() === '' ? undefined : search;
        onSearchKeywordChange(searchKeyword);
    }
    const onKeyPress = (e) => {
        if(e.key === 'Enter'){
            onSearchChange()
        }
        if(e.key === 'Escape'){
            handleRemoveSearch()
        }
    }
    const toggleAutoScroll = () => {
        onAutoScrollToggleChange();
    }

    return <div className={`meeting-details-controls-container ${showAutoScroll ? '' : 'align-items-left'}`}>
        <div className={"colored-border-on-focus"}>
            <Paper classes={{root: 'search-keyword-container'}} style={{width: searchStarted ? 324 : 200}}>
                <IconButton type="button" classes={{root: 'search-icon'}} aria-label="search" onClick={onSearchChange}>
                    <SearchIcon/>
                </IconButton>
                <InputBase
                    classes={{root: 'search-input-field'}}
                    placeholder="Search by keyword"
                    inputProps={{'aria-label': 'search transcription'}}
                    onChange={handleSearchKeywordChange}
                    onKeyDown={onKeyPress}
                    value={search}
                />
                {
                    searchStarted && <IconButton type="button" classes={{root: 'close-icon'}} aria-label="search"
                                                 onClick={handleRemoveSearch}>
                        <CloseIcon/>
                    </IconButton>
                }
                {
                    searchStarted && totalMatchesFound > 0 && <div className={"navigate-matches"}>
                        <IconButton type="button" classes={{root: 'previous-search-match-icon'}}
                                    aria-label="previous-searched-item" onClick={goToPreviousSearchedItem}>
                            <PreviousSearchIcon/>
                        </IconButton>
                        <p className={"current-match-index"}>{currentSearchIndex + 1}/{totalMatchesFound}</p>
                        <IconButton type="button" classes={{root: 'next-search-match-icon'}} aria-label="next-searched-item"
                                    onClick={goToNextSearchedItem}>
                            <NextSearchIcon/>
                        </IconButton>
                    </div>
                }
                {
                    searchStarted && totalMatchesFound === 0 && <p className={"no-matches-found"}>0 matches</p>
                }
            </Paper>
        </div>
        {
            showAutoScroll && <div className={"auto-scroll"}>
                <p>Auto Scroll</p><CustomSwitch defaultChecked onClick={toggleAutoScroll} />
            </div> 
        }
    </div>
}
export default MeetingDetailsControls;

MeetingDetailsControls.prototype = {
    onSearchKeywordChange: PropTypes.func,
    onAutoScrollToggleChange: PropTypes.func,
    goToNextSearchedItem: PropTypes.func,
    goToPreviousSearchedItem: PropTypes.func,
    showAutoScroll: PropTypes.bool,
    currentSearchIndex: PropTypes.number,
    totalMatchesFound: PropTypes.number
}